export const API_JWT_ACCESS_URL = "https://sso.trueshape.sg/sso/api/token/"; //JWT access token API
export const API_JWT_REFRESH_URL =
  "https://sso.trueshape.sg/sso/api/token/refresh/"; //JWT refresh token API
export const API_JWT_BOOTSTRAP_URL =
  "https://sso.trueshape.sg/sso/api/token/bootstrap/"; //JWT bootstrap token API
export const API_LOGOUT_URL = "https://sso.trueshape.sg/sso/api/logout/";
export const API_SSO_USER_URL = "https://sso.trueshape.sg/user/"; //JWT access token API
export const API_SSO_ALL_USER_URL = "https://sso.trueshape.sg/user/all/"; //SSO User All API
export const API_CREATE_USER_URL = "https://sso.trueshape.sg/user/signup/"; //SSO User API
export const API_UPDATE_USER_URL = "https://sso.trueshape.sg/user/update/"; //Update SSO User API
export const API_FORGOT_PASSWORD_URL =
  "https://sso.trueshape.sg/user/reset-password-request/"; //Forgot Password API
// export const API_RESET_PASSWORD_URL =
//   'https://127.0.0.1:8000/user/reset-password/'; //Forgot Password API
export const API_COUNTRY_URL = "https://sso.trueshape.sg/user/countries/"; //List all country list API
export const API_BRANCH_URL = "https://sso.trueshape.sg/organization/branch/"; //Branch API
export const API_SERVICE_URL = "https://sso.trueshape.sg/sso/service/all/"; //Service API
export const API_CONNECTION_URL =
  "https://sso.trueshape.sg/sso/connection/new/"; //Connection API
export const API_ORGANIZATION_HRM_URL =
  "https://shrm.trueshape.sg/organization/all/"; //Organization API

export const API_DEPARTMENT_URL = "https://shrm.trueshape.sg/hrm/departments/"; //Department API
export const API_JOBTITLE_URL = "https://shrm.trueshape.sg/hrm/jobtitles/"; //Job Title API
export const API_SALARY_URL = "https://shrm.trueshape.sg/hrm/salaries/"; //Salary API
export const API_SALARY_CAL_URL =
  "https://shrm.trueshape.sg/hrm/salaries/latest/"; //Trigger Calculate Salary API
export const API_ETHNICITY_URL = "https://shrm.trueshape.sg/hrm/ethnicitys/"; //Ethnicity API
export const API_WORK_PASS_TYPE_URL =
  "https://shrm.trueshape.sg/hrm/workpasstypes/"; // Work Pass Type API
export const API_RESIDENTIAL_STATUS_URL =
  "https://shrm.trueshape.sg/hrm/residentialstatuses/"; //Residential Status API
export const API_CPF_RATE_URL = "https://shrm.trueshape.sg/hrm/cpf-rates/"; //CPF Rate API
export const API_SHG_RATE_URL = "https://shrm.trueshape.sg/hrm/shg-rates/"; //SHG Rate API
export const API_SDL_RATE_URL = "https://shrm.trueshape.sg/hrm/sdl-rates/"; //SDL Rate API
export const API_EMPLOYEE_URL = "https://shrm.trueshape.sg/hrm/employees/"; //Employee API
export const API_POSTJOBDETAIL_URL =
  "https://shrm.trueshape.sg/hrm/postjobdetails/"; //Job Details API
export const API_EMERGENCY_CONTACTS_URL =
  "https://shrm.trueshape.sg/hrm/contacts/"; //Emergency Contacts API
export const API_POST_PAYROLL_TRANSACTION_URL =
  "https://shrm.trueshape.sg/hrm/post-payroll-transactions/"; // Calculate Salary and Details
export const API_PAYROLL_TRANSACTION_URL =
  "https://shrm.trueshape.sg/hrm/payroll-transactions/"; // Calculate Salary and Details
export const API_PAYROLL_HTML_URL =
  "https://shrm.trueshape.sg/hrm/payslip/html/"; // Calculate Salary and Details
export const API_PAYROLL_PDF_URL = "https://shrm.trueshape.sg/hrm/payslip/pdf/"; // Calculate Salary and Details
export const API_PAYROLL_MONTHLY_SUMMARY_URL =
  "https://shrm.trueshape.sg/hrm/monthly-summaries/"; // Calculate Salary and Details
export const API_PAYROLL_CPF_DTL_URL =
  "https://shrm.trueshape.sg/hrm/payroll/summary/download-dtl/"; // Download CPF DTL file
export const API_LEAVE_TYPE_URL =
  "https://shrm.trueshape.sg/leave/leave-types/"; // Leave Type
export const API_LEAVE_HOLIDAY_URL =
  "https://shrm.trueshape.sg/leave/holidays/"; // Leave Holiday
export const API_LEAVE_POLICY_URL =
  "https://shrm.trueshape.sg/leave/leave-policies/"; // Leave Policy
export const API_LEAVE_BALANCE_URL =
  "https://shrm.trueshape.sg/leave/leave-balances/"; // Leave Balance
export const API_LEAVE_REQUEST_URL =
  "https://shrm.trueshape.sg/leave/leave-requests/"; // Leave Request
export const API_LEAVE_REQUEST_CALCULATE_URL =
  "https://shrm.trueshape.sg/leave/leave-requests/calculate-days/"; // Leave Request Calculate Days
export const API_USER_URL = "https://shrm.trueshape.sg/user/"; //Users API
// export const API_UPDATE_USER_URL = "https://127.0.0.1:8003/user/profile/"; //Users Update API
export const API_ALL_USER_URL = "https://shrm.trueshape.sg/user/all/"; //All Users API
export const API_USER_GROUP_URL = "https://shrm.trueshape.sg/user/groups/"; //User Group API
export const API_AUDIT_LOG_URL =
  "https://shrm.trueshape.sg/audit/hrm/audit-logs/"; //Audit Log API
export const API_AUDIT_CONFIG_URL =
  "https://shrm.trueshape.sg/audit/hrm/audit-config/"; //Audit Config API
// export const API_PAYMENT_REQUEST = 'https://127.0.0.1:8003/cms/payment-request/'; //Hitpay payment request

export const TIMEOUT_SEC = 30; //API timeout setting
export const MODAL_TIMEOUT_SEC = 1; //API timeout setting
